<template>
  <section id="searchBrand" ref="searchBrand">
    <GarageBrand :brand_name="brand" :brand_id="carBrandId" :color_kv="color" :color_text="color_text"></GarageBrand>
    <div hidden>ZEEKR Pre-owned Cars</div>
  </section>
</template>

<script>
import GarageBrand from '../components/GarageBrand'

let vm = null
export default {
  metaInfo: {
    title: 'Zeekr Pre-owned Cars', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Zeekr Pre-owned Cars'
    },
    {
      name: 'description',
      content: 'Zeekr Pre-owned Cars – Buy premium condition pre-owned cars with warranty.'
    }]
  },
  name: "ZEEKR",
  data() {
    return {
      metaData: 'Zeekr Pre-owned Cars',
      carBrandId: 1044,
      brand: 'ZEEKR',
      color: '#0f0f0f',
      color_text: '#fff4e2',
      favicon: '/favicon_zeekr.ico'
    };
  },
  created() {
  },
  async mounted() {
    this.setFavicon()
  },
  beforeDestroy() {
    this.resetFavicon()
  },
  methods: {
    setFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = this.favicon
      }
    },
    resetFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = '/favicon.ico'
      }
    }
  },
  components: {
    GarageBrand
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Zeekr.vue